import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const GetPricingHubRecentPriceChangesDocument = gql`
  query GetPricingHubRecentPriceChanges {
    getPricingHubRecentPriceChanges {
      base_unit
      cost_in_micros
      event
      gross_profit_percentage
      item_name
      price_in_micros
      restaurant_id
      restaurant_name
      source
      updated_at
      variant_pack_id
      weekly_gp_impact_in_micros
    }
  }
`;
export function useGetPricingHubRecentPriceChangesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GetPricingHubRecentPriceChangesQuery,
    Types.GetPricingHubRecentPriceChangesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetPricingHubRecentPriceChangesQuery,
    Types.GetPricingHubRecentPriceChangesQueryVariables
  >(GetPricingHubRecentPriceChangesDocument, options);
}
export function useGetPricingHubRecentPriceChangesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetPricingHubRecentPriceChangesQuery,
    Types.GetPricingHubRecentPriceChangesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetPricingHubRecentPriceChangesQuery,
    Types.GetPricingHubRecentPriceChangesQueryVariables
  >(GetPricingHubRecentPriceChangesDocument, options);
}
export type GetPricingHubRecentPriceChangesQueryHookResult = ReturnType<
  typeof useGetPricingHubRecentPriceChangesQuery
>;
export type GetPricingHubRecentPriceChangesLazyQueryHookResult = ReturnType<
  typeof useGetPricingHubRecentPriceChangesLazyQuery
>;
export type GetPricingHubRecentPriceChangesQueryResult = Apollo.QueryResult<
  Types.GetPricingHubRecentPriceChangesQuery,
  Types.GetPricingHubRecentPriceChangesQueryVariables
>;

/**
 * Wrapped version of useGeneratedGetPricingHubRecentPriceChangesQuery using Pepper's useWrappedQuery
 */
export function useGeneratedGetPricingHubRecentPriceChangesQuery(
  options?: Apollo.QueryHookOptions<
    Types.GetPricingHubRecentPriceChangesQuery,
    Types.GetPricingHubRecentPriceChangesQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.GetPricingHubRecentPriceChangesQuery,
    Types.GetPricingHubRecentPriceChangesQueryVariables
  >(GetPricingHubRecentPriceChangesDocument, options);
}

/**
 * Wrapped version of useGeneratedGetPricingHubRecentPriceChangesLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedGetPricingHubRecentPriceChangesLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.GetPricingHubRecentPriceChangesQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.GetPricingHubRecentPriceChangesQuery,
    Types.GetPricingHubRecentPriceChangesQueryVariables
  >(GetPricingHubRecentPriceChangesDocument, lazyOptions);
}
